import { render } from "./StorageBrowser.vue?vue&type=template&id=75f23f27"
import script from "./StorageBrowser.vue?vue&type=script&lang=js"
export * from "./StorageBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__